import { Organisation } from 'store/organisation/models';
import { isCaptureTabShellReady } from './use-capture-tab-ready';

/** True when the entity has uploaded or scanned capture documents. */
export function hasCaptureDocumentsActivity(
  organisation?: Organisation | null,
  hasTransactions?: boolean
): boolean {
  const files = organisation?.excelFilesMetadata;
  if (Array.isArray(files) && files.length > 0) {
    return true;
  }
  return Boolean(hasTransactions);
}

/**
 * Matches Capture Documents tab usage: shell has loaded at least once this session,
 * or capture documents have produced files / transactions.
 */
export function isCaptureDocumentsUsed(options: {
  organisationId?: string;
  organisation?: Organisation | null;
  hasTransactions?: boolean;
}): boolean {
  if (isCaptureTabShellReady(options.organisationId)) {
    return true;
  }
  return hasCaptureDocumentsActivity(
    options.organisation,
    options.hasTransactions
  );
}
